export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14408.de02d932.jpg";